import { LoadingScreen } from "@waldner-laboreinrichtungen/component-system";
import { useTranslation } from "react-i18next";

export const LoadingScreenWithText = () => {
  const { t } = useTranslation();
  return <LoadingScreen loadingText={t("loading.text")} />;
};
